import React from 'react'
import certificate from '../Image/certificate.jpg'
function Strengths_comp() {
  return (
    <div>
      {/* ------------------------------Mobile View--------------------------- */}
    <div className=' stregths_page_img d-sm-block d-md-none mb-4'>
    <div className='container pt-4'>
    <div className='text-center'>
    <span className=" display-4 staff_component_text">Our Strengths</span>
        <p className="pt-2 fs-6 mb-md-5 pb-md-0">Our features are what make us who we are.</p>
    </div>
    </div>
    <div className='container px-3'>
    <div className='row pt-2'>
    <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>6 Month Course Access</p>
                <p className='mobile_strength_component_text_p'>We provide 6 month course access to a variety of courses that will help you stay ahead of the curve in your field.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text'>Live Session & Mentorship</p>
                <p className='mobile_strength_component_text_p'>Discover dynamic live courses led by experts, tailored to your needs. Our impactful approach includes personalized guidance, empowering you to exceed goals.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Capstone Projects</p>
                <p className='mobile_strength_component_text_p'>Dedicated to delivering well-written, researched projects. We understand the importance of excellence, ensuring your work meets the highest standards.</p>
            </div>
        </div>
    </div>
    <div className='row'>
    <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Live Skill Development Session</p>
                <p className='mobile_strength_component_text_p'>Empower your career with Live Skill Development experts guide resume building, pre-interview prep, LinkedIn optimization, mastering interviews. Success in today's dynamic job market awaits!</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text'>Paid Internship Opportunity</p>
                <p className='mobile_strength_component_text_p'>Explore paid internships in our courses. Elevate your career with hands-on experience. Completion opens doors to exciting paid opportunities for a dynamic professional journey.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Certifications</p>
                <p className='mobile_strength_component_text_p'>Gain recognition with our Internship and Course Completion Certificates. Showcase achievements and skills to employers with our validated certifications.</p>
            </div>
        </div>
    </div>
    </div>
    </div>

    {/* ----------------------------Desktop View-------------------------------- */}
    <div className='stregths_page_img d-none d-md-block mb-2'>    
    <div className='container py-5'>
    <div className='text-center'>
    <span className=" display-4 staff_component_text ">Our Strengths</span>
        <p className="pt-3 fs-5 pb-5 mb-md-5 pb-md-0">Our features are what make us who we are.</p>
    </div>
    <div className='container '>
    <div className='row px-5'>
    <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>6 Month Course Access</p>
                <p className=''>We provide 6 month course access to a variety of courses that will help you stay ahead of the curve in your field.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text'>Live Session & Mentorship</p>
                <p className=''>Discover dynamic live courses led by experts, tailored to your needs. Our impactful approach includes personalized guidance, empowering you to exceed goals.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Capstone Projects</p>
                <p className=''>Dedicated to delivering well-written, researched projects. We understand the importance of excellence, ensuring your work meets the highest standards.</p>
            </div>
        </div>
    </div>
    <div className='row mt-3 px-5'>
    <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Live Skill Development Session</p>
                <p className=''>Empower your career with Live Skill Development—experts guide resume building, pre-interview prep, LinkedIn optimization, mastering interviews. Success in today's dynamic job market awaits!</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text'>Paid Internship Opportunity</p>
                <p className=''>Explore paid internships in our courses. Elevate your career with hands-on experience. Completion opens doors to exciting paid opportunities for a dynamic professional journey.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <p className='fs-4 fw-bold staff_component_text '>Certifications</p>
                <p className=''>Gain recognition with our Internship and Course Completion Certificates. Showcase achievements and skills to employers with our validated certifications.</p>
            </div>
        </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  )
}

export default Strengths_comp
